import { render, staticRenderFns } from "./TranslationButton.vue?vue&type=template&id=aed0b170&scoped=true&"
import script from "./TranslationButton.vue?vue&type=script&lang=js&"
export * from "./TranslationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed0b170",
  null
  
)

export default component.exports